import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import LoadingIndicator from '../../../common/components/LoadingIndicator'
import { ReactComponent as BackIcon } from '../../../common/icons/back_icon.svg'
import { useGetAttemptsQuery } from '../../../api/trainingPackages/trainingPackages'
import StatusComponent from '../TrainingTable/StatusComponent'
import UsersTrainingHistoryTable from './UsersTrainingHistoryTable'
import userService from 'src/services/user.service'

export default function UsersTrainingHistory() {
  const { id, userId } = useParams()
  const [user, setUser] = useState(null)
  const { data, isLoading } = useGetAttemptsQuery({ id, userId })

  useEffect(() => {
    userService.getUser(userId).then(resp => {
      setUser(resp.data)
    })
  }, [])
  const navigate = useNavigate()
  if (isLoading) {
    return (
      <Box display='flex' height='100vh' alignItems='center'>
        <LoadingIndicator />
      </Box>
    )
  }

  return (
    <Box
      width='100%'
      display='flex'
      flexDirection='column'
      p='32px 48px'
      rowGap={1}
      bgcolor='#F8F8FB'
      minHeight='100vh'
    >
      <Box display='flex' columnGap={3} alignItems='center'>
        <Button
          onClick={() => navigate(window.location.pathname.split('/users-training-history/')[0])}
          sx={{ fontWeight: 500, textTransform: 'none', fontSize: '16px', color: '#6123FF', fontFamily: 'Satoshi' }}
          startIcon={<BackIcon />}
          variant='text'
        >
          Back to Training
        </Button>
        <StatusComponent status={data.status} />
      </Box>
      <Box display='flex' columnGap='80px'>
        <Box>
          <Typography
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 900,
              fontFamily: 'Satoshi',
              fontSize: '36px',
              pb: '8px'
            }}
          >
            {user?.firstName} {user?.lastName}
          </Typography>
          <Typography
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 600,
              color: '#76767F',
              fontFamily: 'Plus Jakarta Sans',
              fontSize: '16px',
              pb: '8px'
            }}
          >
            {user?.email}
          </Typography>
        </Box>
      </Box>

      <UsersTrainingHistoryTable data={data} isLoading={isLoading} />
    </Box>
  )
}
